import {
    CarWithoutPerformancePlanModel,
    EditablePerformancePlan,
    LogistWithoutPerformancePlanModel,
    OrganizationPerformancePlanModel,
    PerformancePlanChangeLogModel,
    PerformancePlanExecutionModel,
} from "helpers/models/performancePlans";
import { alertRequest, body, request } from "services/request";

const resource = "api/performancePlans";

const formatMonthForApi = (month: string): string => {
    if (!month) {
        return month;
    }
    return month.length === 7 ? `${month}-01` : month;
};

export const getPerformancePlan = (month: string): Promise<OrganizationPerformancePlanModel> =>
    request(`${resource}/get?month=${encodeURIComponent(formatMonthForApi(month))}`, { method: "GET" });

export const getPerformancePlanChanges = (month: string): Promise<PerformancePlanChangeLogModel[]> =>
    request(`${resource}/getChanges?month=${encodeURIComponent(formatMonthForApi(month))}`, { method: "GET" });

export const getPerformancePlanExecution = (month: string): Promise<PerformancePlanExecutionModel> =>
    request(`${resource}/getExecution?month=${encodeURIComponent(formatMonthForApi(month))}&groupByCurrentLogist=false`, {
        method: "GET",
    });

export const getCarsWithoutPerformancePlan = (month: string): Promise<CarWithoutPerformancePlanModel[]> =>
    request(`${resource}/getCarsWithoutPlan?month=${encodeURIComponent(formatMonthForApi(month))}`, { method: "GET" });

export const getLogistsWithoutPerformancePlan = (month: string): Promise<LogistWithoutPerformancePlanModel[]> =>
    request(`${resource}/getLogistsWithoutPlan?month=${encodeURIComponent(formatMonthForApi(month))}`, { method: "GET" });

export const applyOrganizationPerformancePlan = (plan: EditablePerformancePlan) =>
    alertRequest(
        `${resource}/applyOrganizationPlan`,
        body({
            month: formatMonthForApi(plan.month),
            autoCopyToNextMonth: plan.autoCopyToNextMonth,
            mileagePlan: plan.mileagePlan,
            overallBidsPricePlan: plan.overallBidsPricePlan,
        }),
    );

export const applyLogistsPerformancePlan = (plan: EditablePerformancePlan) =>
    alertRequest(
        `${resource}/applyLogistsPlan`,
        body({ month: formatMonthForApi(plan.month), items: plan.logistsPlans }),
    );

export const applyCarsPerformancePlan = (plan: EditablePerformancePlan) =>
    alertRequest(
        `${resource}/applyCarsPlan`,
        body({ month: formatMonthForApi(plan.month), items: plan.carsPlans }),
    );
